<section class="page">
  <div class="page__content">
    <div class="page__text">
      <h1 class="page__title">
        <span
          class="page__title-accent"
          [innerHTML]="'workflowSlePlus.title' | translate"
        ></span>
        <span
          class="page__title-main"
          [innerHTML]="'workflowSlePlus.subtitle' | translate"
        ></span>
      </h1>
      <p class="page__description">
        {{ 'workflowSlePlus.description' | translate }}
      </p>
      <button
        kendoButton
        themeColor="primary"
        size="large"
        class="page__action"
        maximizerShowcaseBookDemo
      >
        {{ 'workflowSlePlus.button.action' | translate }}
      </button>
    </div>
    <div class="page__media">
      <img
        [src]="cdn + '/assets/images/showcase/workflow.svg'"
        [alt]="'workflowSlePlus.image.alt' | translate"
        class="page__image"
      />
    </div>
  </div>
</section>
